import { Component, Input, OnInit, output, input } from "@angular/core";

@Component({
  selector: 'FloatingLabelInput',
  imports: [],
  template: `
    <div class="relative">
      <div class="flex flex-row">
        <input #myInput autofocus [value]="myValue ? myValue : ''"
               (focus)="focused = true"
               (blur)="focused = false"
               [readonly]="readonly()"
               (input)="onChange(myInput.value)"
               [class.border-0]="valid()" [class.border-red-500]="!valid()"
               [class.focus:border-red-500]="!valid()" [type]="showPassword ? 'text' : type()" id="id_{{id()}}"
               class="my-input flex-grow drop-shadow-sm font-medium block rounded-lg px-3 pb-2 pt-5 w-full text-sm text-gray-900 bg-gray-50 dark:bg-gray-800 appearance-none dark:text-white focus:outline-none focus:ring-0 peer"
               placeholder=" "/>
        <label for="id_{{id()}}" [style.color]="!valid() ? 'red' : (focused ? (appColor ? appColor : '') : '')"
               class="absolute text-sm duration-300 dark:text-white transform -translate-y-3 scale-75 top-4 z-10 origin-[0] left-3 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3">{{ label() }}</label>
        <ng-content></ng-content>
        @if (type() === 'password') {
          <i (click)="showPassword = !showPassword"
             [class.fa-eye]="!showPassword"
             [class.fa-eye-slash]="showPassword"
             class="fas p-5 right-0 absolute cursor-pointer"></i>
        }
      </div>
      @if (description) {
        <div class="ml-2 mt-1 text-xxs font-medium text-gray-600">{{ description }}</div>
      }
      @if (error) {
        <div class="ml-2 mt-1 text-xxs font-medium text-red-500">{{ error }}</div>
      }
    </div>
  `,
})
export class FloatingLabelInput implements OnInit {
  readonly id = input<string>();
  readonly label = input<string>();
  @Input() myValue: string;
  readonly type = input<"text" | "password">("text");
  readonly valid = input(true);
  readonly readonly = input(false);
  @Input() appColor = "unset";
  @Input() description;
  @Input() error;
  myValueChange = output<string>();

  focused = false;
  showPassword = false;

  ngOnInit(): void {
    if (!!this.myValue) {
      this.myValueChange.emit(this.myValue);
    }
  }

  onChange(value: string) {
    this.myValueChange.emit(value);
  }
}
